'use client';

import FollowButton from '@fe-news/components/atoms/Member/FollowButton';
import useTrackTags from '@fe-news/components/molecules/NewsTrackingBar/hooks/use-track-tags';
import LoginModal from '@fe-news/components/molecules/LoginModal';
import useLoginModal from '@fe-news/hooks/use-login-modal';
import { CustomEventName, GTMEventKey, sendGTM } from '@fe-cnyes/fe-common-gtm';

type RankingListHotTagServerProps = {
  id: string;
};

const HotTagFollowButton = ({ id }: RankingListHotTagServerProps) => {
  const { isLoggedIn, isCloseLoginModal, onClickLoginModalOpen, onClickLoginModalClose } = useLoginModal({
    defaultCloseLoginModal: true
  });

  const { isTracked, addTagMutate, removeTagMutate, isLoading } = useTrackTags({
    tagId: id,
    isLogin: isLoggedIn,
    isUserNoTracked: true
  });

  const onClickTrack = async () => {
    if (isLoggedIn) {
      try {
        if (isTracked) {
          await removeTagMutate(id);
        } else {
          await addTagMutate(id);

          const GTM_EVENT = {
            [GTMEventKey.EVENT_NAME]: CustomEventName.FOLLOW_TAG,
            [GTMEventKey.SECTION]: 'News_Category_熱門排行',
            [GTMEventKey.CLICK_ITEM]: `熱門追蹤標簽＿${id}`
          };
          sendGTM(GTM_EVENT);
        }
      } catch (error) {
        console.error(`[ACTION ERROR]: ranking list hot tag tracking error : ${id}`, error);
      }
    } else {
      onClickLoginModalOpen();
    }
  };

  return (
    <>
      <LoginModal isModalClosed={isCloseLoginModal} onClickModalClose={onClickLoginModalClose} />
      <FollowButton onClickTrack={onClickTrack} isTracked={isTracked} isLoading={isLoading} />
    </>
  );
};

export default HotTagFollowButton;
